/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteContactsRequest} from '@cash-web/protos/squareup/franklin/app/contacts.pb'
import {DeleteContactsResponse} from '@cash-web/protos/squareup/franklin/app/contacts.pb'


export const deleteContacts = (request:DeleteContactsRequest, options?: CashRequestOptions) => post<DeleteContactsRequest, DeleteContactsResponse>("/2.0/cash/delete-contacts", request, {...options, rejectOnError: true })